import React from 'react';
import styled from 'styled-components';
import PrintViewKnowledgeDescription from './PrintViewKnowledgeDescription';
import {GetCardTypeForBody} from '../../../../../util/utils';

function PrintViewKnowledgeBody(props) {
	const {body} = props;

	const formBodyBorder = GetCardTypeForBody(body);

	return (
		<StyledPrintViewKnowledgeBody className={`StyledPrintViewKnowledgeBody ${formBodyBorder}`}>
			{body && body.id > 0 && <PrintViewKnowledgeDescription body={body} bodyDescription={body.name} />}
		</StyledPrintViewKnowledgeBody>
	);
}

export default PrintViewKnowledgeBody;

const StyledPrintViewKnowledgeBody = styled.section``;
